import {
  keepPreviousData,
  QueryCache,
  QueryClient,
} from "@tanstack/react-query";
import { toast } from "sonner";
import { getBackgroundQueryErrorToast } from "@/lib/query-failure";

type QueryMeta = {
  suppressBackgroundErrorToast?: boolean;
};

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      const meta = query.meta as QueryMeta | undefined;
      if (meta?.suppressBackgroundErrorToast) {
        return;
      }

      if (query.state.data === undefined) {
        return;
      }

      const toastContent = getBackgroundQueryErrorToast(error);
      if (!toastContent) {
        return;
      }

      toast.error(toastContent.title, {
        id: "query-background-error",
        description: toastContent.description,
      });
    },
  }),
  defaultOptions: {
    mutations: {
      networkMode: "always",
      retry: false,
    },
    queries: {
      networkMode: "always",
      placeholderData: keepPreviousData,
      retry: false,
    },
  },
});

export function showBackgroundQueryErrorToast(error: unknown) {
  const toastContent = getBackgroundQueryErrorToast(error);
  if (!toastContent) {
    return;
  }

  toast.error(toastContent.title, {
    id: "query-background-error",
    description: toastContent.description,
  });
}
